<script>
  import { onMount } from 'svelte';
  import { request } from '../utils/request';
  import { sessionStore } from '../stores';
  let usage = [], purchases = [], cursor = null, hasMore = false, loading = false, error = '', message = '', tab = 'usage';
  async function loadUsage(reset = false) {
    if (loading) return;
    loading = true; error = '';
    try {
      const data = await request(`/api/work_history/${$sessionStore.userId}?limit=30${!reset && cursor ? `&cursor=${cursor}` : ''}`);
      usage = reset ? data.items : [...usage, ...data.items]; cursor = data.next_cursor; hasMore = data.has_more;
    } catch (e) { error = e.message; } finally { loading = false; }
  }
  async function loadPurchases() {
    loading = true; error = '';
    try { purchases = (await request('/api/purchase_history')).purchases || []; }
    catch (e) { error = e.message; } finally { loading = false; }
  }
  async function refund(purchase) {
    if (loading || !confirm('이 결제의 환불 검토를 요청할까요?')) return;
    loading = true; error = '';
    try { await request('/api/request_refund', { method: 'POST', body: { purchase_id: purchase.id, user_email: $sessionStore.email } }); message = '환불 검토 요청을 접수했습니다.'; }
    catch (e) { error = e.message; }
    finally { loading = false; }
    await loadPurchases();
  }
  function options(item) { try { const data = typeof item.function_option === 'string' ? JSON.parse(item.function_option) : item.function_option; return data?.style || data?.selectedStyle || ''; } catch { return ''; } }
  onMount(() => { loadUsage(true); });
</script>
<div class="activity">
  <h2>이용 내역</h2>
  <div class="tabs"><button on:click={() => tab = 'usage'} aria-pressed={tab === 'usage'}>RION 사용 내역</button><button on:click={() => { tab = 'purchases'; loadPurchases(); }} aria-pressed={tab === 'purchases'}>결제·환불 내역</button></div>
  {#if loading}<p role="status">불러오는 중...</p>{/if}
  {#if error}<p role="alert">{error} <button on:click={() => tab === 'usage' ? loadUsage(true) : loadPurchases()}>다시 시도</button></p>{/if}
  {#if message}<p role="status">{message}</p>{/if}
  <div class="table-wrap"><table>
    <thead><tr><th>일시</th><th>{tab === 'usage' ? '작업' : '결제'}</th><th>RION</th><th>상태</th></tr></thead>
    <tbody>
      {#if tab === 'usage'}
        {#each usage as item}<tr><td>{new Date(item.used_at).toLocaleString()}</td><td>{options(item) || item.function_name}</td><td>{item.coin_refunded ? '반환됨' : `−${item.coin_cost ?? 0}`}</td><td>{item.process_status === 'completed' ? '완료' : item.process_status === 'failed' ? '실패' : '진행 중'}</td></tr>{/each}
      {:else}
        {#each purchases as item}<tr><td>{new Date(item.purchase_date).toLocaleString()}</td><td>{Number(item.amount).toLocaleString()}원</td><td>+{item.credits}</td><td>{item.status}{#if !String(item.status).includes('환불')} <button disabled={loading} on:click={() => refund(item)}>환불 검토 요청</button>{/if}</td></tr>{/each}
      {/if}
    </tbody>
  </table></div>
  {#if tab === 'usage' && hasMore}<button disabled={loading} on:click={() => loadUsage()}>이전 사용 내역 더 보기</button>{/if}
  {#if !loading && !(tab === 'usage' ? usage.length : purchases.length)}<p>아직 내역이 없습니다.</p>{/if}
</div>
<style>
  .tabs { display: flex; gap: 8px; margin-bottom: 20px; } button { border: 1px solid #8885; border-radius: 8px; padding: 9px 12px; color: inherit; background: transparent; cursor: pointer; font: inherit; }
  button[aria-pressed=true] { color: #e56831; border-color: #e56831; } .table-wrap { overflow: auto; } table { border-collapse: collapse; width: 100%; text-align: left; font-size: .9rem; } th, td { padding: 14px 10px; border-bottom: 1px solid #8883; } td { line-height: 1.6; } [role=alert] { color: #c9442f; }
</style>
